// extracted by mini-css-extract-plugin
export default {"buildingManagementToolbar":"toolbar_buildingManagementToolbar__bHzcY"};